import type { AsyncData } from '#app';
import type {
  IModelListQueryParamsRequest,
  IModelResponse,
} from '~/services/base/dto/base.dto';
import type {
  IModelChatHistoryResponse,
  IModelContactResponse,
  IModelManualSetStateRequest,
  IModelManualSetStateResponse,
  IModelManualHandoffRequest,
  IModelManualHandoffResponse,
} from './dto/conversation-history.dto';


export class ConversationHistoryRepository {
  private api: any;
  private configService: any;
  private tgSocialService: any;
  private tgSocialBase: any;
  private tgWebchatService: any;
  private tgWebchatBase: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.tgSocialService = runtimeConfig.public.apiTGSocialService;
    this.tgSocialBase = runtimeConfig.public.apiTGSocialBase;
    this.tgWebchatService = runtimeConfig.public.apiTGWebchatService;
    this.tgWebchatBase = runtimeConfig.public.apiTGWebchatBase;
  }

  async getContactList(
    params: any
  ): Promise<AsyncData<IModelResponse<IModelContactResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.tgSocialService}v1/message-presenter/chat-users`,
      this.configService,
      {
        baseUrl: this.tgSocialBase,
        method: 'POST',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async getChatHistoryList(
    params: any
  ): Promise<AsyncData<IModelResponse<IModelChatHistoryResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.tgSocialService}v1/message-presenter/chat-history`,
      this.configService,
      {
        baseUrl: this.tgSocialBase,
        method: 'POST',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async manualSetState(
    params: IModelManualSetStateRequest
  ): Promise<AsyncData<IModelManualSetStateResponse, any>> {
    const dataResult = await this.api(
      `${this.tgSocialService}v1/message-presenter/manual-set-state`,
      this.configService,
      {
        baseUrl: this.tgSocialBase,
        method: 'POST',
        body: params,
      }
    );
    return dataResult;
  }

  // Webchat / mobile webview users are handed off by TG-social-webchat-service.
  async manualHandoffWebchat(
    params: IModelManualHandoffRequest
  ): Promise<AsyncData<IModelManualHandoffResponse, any>> {
    const dataResult = await this.api(
      `${this.tgWebchatService}v1/message-presenter/backoffice/manual-handoff`,
      this.configService,
      {
        baseUrl: this.tgWebchatBase,
        method: 'POST',
        body: params,
      }
    );
    return dataResult;
  }
}
